<form >

  <div class="row justify-content-center" >
    <!--<mat-card>-->
    <h2 class="mat-h2" mat-dialog-title>{{formInput.title}}</h2>

    <p class="contenido">Usted ha sido vinculado como {{formInput.nombre_rol}}
      con la entidad productiva {{formInput.empresa}} con las siguientes actividades:</p>
    <div *ngFor="let choice of actividadesCheck; let indice=index" class="col-md-12">
      <label>
        <input type="checkbox" [value]="choice.value" (change)="onCheckChange($event,indice)" checked>
        {{choice.rolActividadConNombre.nombreActividad}}
      </label>
    </div>

    <mat-error *ngIf="actividadSinCheck">
      Las actividades no seleccionadas serán dadas de baja.
    </mat-error>
    <mat-error *ngIf="sinActividades">
      Debe seleccionar al menos una actividad.
    </mat-error>



    <!--</mat-card>-->
  </div>
</form>
